export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00108.05bc4607.png";